import React from 'react';
import SuggestedQuestions from './SuggestedQuestions';
import { Sidebar } from './styles';

interface WidgetSidebarProps {
  isOpen: boolean;
  isDarkMode: boolean;
  onQuestionClick: (question: string) => void;
}

const WidgetSidebar: React.FC<WidgetSidebarProps> = ({
  isOpen,
  isDarkMode,
  onQuestionClick,
}) => {
  return (
    <Sidebar isOpen={isOpen} isDarkMode={isDarkMode}>
      <SuggestedQuestions
        isOpen={isOpen}
        isDarkMode={isDarkMode}
        onQuestionClick={onQuestionClick}
      />
    </Sidebar>
  );
};

export default WidgetSidebar;
